import httpServe from './http'

let userSercive = {}

userSercive.login = async (params) => {
  let url = httpServe.getApiUrl('/oauth/token')
  let res = await httpServe.login(url, params)
  return res['data']
}
userSercive.logout = async () => {
  let url = httpServe.getApiUrl('/pub/superUser/logout')
  let res = await httpServe.ajaxGet(url, {},true)
  return res['data']
}

userSercive.resetPwd = async (params) => {
  let url = httpServe.getApiUrl('/api/user/changeMyPassword')
  let res = await httpServe.ajaxPost(url, params, true)
  return res['data']
}

userSercive.getCode = async () => {
  let url = httpServe.getApiUrl('/pub/superUser/vCode')
  let res = await httpServe.ajaxPost(url, {}, true)
  return res['data']
}

// 获取用户信息
userSercive.getUserInfo = async () => {
  let url = httpServe.getApiUrl('/api/user/loadUserInfo')
  let res = await httpServe.ajaxGet(url, {},true)
  return res['data']
}
// 修改用户信息
userSercive.updateUserInfo = async (params) => {
  let url = httpServe.getApiUrl('/api/user/updateUserInfo')
  let res = await httpServe.ajaxPost(url, params, true)
  return res['data']
}

// 修改状态
userSercive.setStatus = async (params) => {
  let url = httpServe.getApiUrl('/api/user/batchSetBaseStatus')
  let res = await httpServe.ajaxPost(url, params, true)
  return res['data']
}


// 获取员工列表
userSercive.getStaffList = async (params) => {
  let url = httpServe.getApiUrl('/api/user/queryUsers')
  let res = await httpServe.ajaxPost(url, params, true)
  return res['data']
}

/**
 * 按角色查询用户 
 */
userSercive.queryUsersByRole = async function (data) {
  const url = httpServe.getApiUrl('/api/user/queryUsersByRole')
  const res = await httpServe.ajaxPost(url, data, true)
  return res['data']
}

// 添加员工
userSercive.addStaff = async (params) => {
  let url = httpServe.getApiUrl('/api/user/addUser')
  let res = await httpServe.ajaxPost(url, params, true)
  return res['data']
}

/**
 * 删除员工
 * @param {Object} data { userIds }
 */
userSercive.batchRemoveUser = async function (data) {
  const url = httpServe.getApiUrl('/api/user/batchRemoveUser')
  const res = await httpServe.ajaxPost(url, data)
  return res['data']
}

// 设置角色
userSercive.setRole = async (params) => {
  let url = httpServe.getApiUrl('/api/auth/saveUserRole')
  let res = await httpServe.ajaxPost(url, params, true)
  return res['data']
}
// 批量设置角色
userSercive.batchSaveUserRole = async (params) => {
  let url = httpServe.getApiUrl('/api/auth/batchSaveUserRole')
  let res = await httpServe.ajaxPost(url, params, true)
  return res['data']
}
// 角色列表
userSercive.getRoleList = async (params) => {
  let url = httpServe.getApiUrl('/api/auth/queryRole')
  let res = await httpServe.ajaxPost(url, params, true)
  return res['data']
}
// 角色列表
userSercive.getRoleListV2 = async (params) => {
  let url = httpServe.getApiUrl('/api/auth/queryRole')
  let res = await httpServe.ajaxPost(url, params, true)
  return res['data']
}

// 添加角色
userSercive.addRole = async (params) => {
  let url = httpServe.getApiUrl('/api/auth/saveRole')
  let res = await httpServe.ajaxPost(url, params, true)
  return res['data']
}

// 角色详情
userSercive.getRoleDetail = async (params) => {
  let url = httpServe.getApiUrl('/api/auth/findRoleById')
  let res = await httpServe.ajaxPost(url, params, true)
  return res['data']
}

// 角色详情
userSercive.delRole = async (params) => {
  let url = httpServe.getApiUrl('/api/auth/deleteRole')
  let res = await httpServe.ajaxPost(url, params, true)
  return res['data']
}


export default userSercive